import { Outlet } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { BatchProvider } from '@/contexts/BatchContext';

import Sidebar from './Sidebar';
import Header from './Header';
import BatchGuard from './BatchGuard';
import { User as AppUser } from '@/types';

const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { user } = useAuth();

  // Close sidebar when window is resized to desktop size
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) { // lg breakpoint in Tailwind
        setSidebarOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Log sidebar state changes and toggle body class
  useEffect(() => {
    console.log('Sidebar state changed:', sidebarOpen);

    // Toggle body class to prevent scrolling when sidebar is open
    if (sidebarOpen) {
      document.body.classList.add('sidebar-open');
    } else {
      document.body.classList.remove('sidebar-open');
    }
  }, [sidebarOpen]);

  // Cast the user to the correct type
  const typedUser = user as AppUser | null;

  return (
    <BatchProvider>
      <div className="flex h-screen overflow-hidden flex-col">

        <div className="flex flex-1 overflow-hidden">
          {/* Sidebar - fixed width, always visible on desktop */}
          <Sidebar
            sidebarOpen={sidebarOpen}
            setSidebarOpen={setSidebarOpen}
          />

          {/* Main Content */}
          <div className="flex flex-col flex-1 overflow-hidden relative">
            <Header
              sidebarOpen={sidebarOpen}
              setSidebarOpen={setSidebarOpen}
              user={typedUser}
            />

            <main className="flex-1 overflow-y-auto bg-gray-50 p-4 md:p-6">
              <BatchGuard>
                <Outlet />
              </BatchGuard>
            </main>

            {/* Overlay to prevent interaction with main content when sidebar is open on mobile */}
            {sidebarOpen && (
              <div
                className="absolute inset-0 bg-black/20 z-30 lg:hidden"
                onClick={() => setSidebarOpen(false)}
              />
            )}
          </div>
        </div>
      </div>
    </BatchProvider>
  );
};

export default Layout;
